module.exports = __webpack_public_path__ + "static/media/image_1.3af3c5b7.png";